module.exports = __webpack_public_path__ + "media/images/emblems/Schluein_wappen-6a5e762babda74f101cee77d6ab1c204.svg";